import { WithThumbnailFile } from "../../common/types/Data/File";
import { addFileURLToList } from "./addFileURLToList";

export const addThumbnailURLToList = (entity: WithThumbnailFile, list: string[]): string[] => {
    return addFileURLToList(entity.thumbnailFile, list);
};
